import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { Regiao } from '../../../regiao';
import { ConfigServerService, CustomHttp } from '../../../../../core';
import { RegiaoIntegracaoImportFilter } from '../../regiao-integracao-import-filter';

@Injectable({
    providedIn: 'root'
})
export class RegiaoIntegracaoErpImportHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegrationErp()}/regiao`;
    }

    /** Realiza a importação das regiões através da integração com o ERP */
    importMany(filter: RegiaoIntegracaoImportFilter): Observable<Regiao[]> {
        return this.customHttp.post<Regiao[]>(`${this.pathApi}/0/import/many`, filter);
    }

    /* Realiza a importação da região informado através da integração com o ERP **/
    importOne(idRegiao: number): Observable<Regiao> {
        return this.customHttp.get<Regiao>(`${this.pathApi}/${idRegiao}/import/one`);
    }
}
